import { render, staticRenderFns } from "./AdminGatewayTypeSettings.vue?vue&type=template&id=104148b2&"
import script from "./AdminGatewayTypeSettings.vue?vue&type=script&lang=ts&"
export * from "./AdminGatewayTypeSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports